<template>
  <div>
    <v-form ref="form">
      <v-card class="fullForm">
        <app-row title="دوره" :value="cycle.Title" icon="" />
        <app-row title="ارزيابي كننده: " :value="fullName" icon="" />
        <app-row title="ارزيابي شونده: " :value="recipientDesc" icon="" />
        <div style="padding: 12px">
          <hr style="margin-bottom: 30px" />
          <v-row
            align="center"
            :style="[index % 2 == 1 ? { backgroundColor: 'rgba(0,0,255,0.1)' } : '']"
            style="padding-top: 10px"
            v-for="(question, index) in questions"
            :key="question.FSerial"
          >
            <template>
              <v-col class="d-flex" cols="12" sm="6">
                {{ index + 1 }}{{ "-      " }}
                {{ question.Title }}
              </v-col>
              <v-col cols="12">
                <template v-if="question.Type == 1">
                  <v-radio-group
                    :rules="[rules.requiredSelect]"
                    v-model="answers[index].answer['RadioAnswer']"
                    class="pollRadio"
                  >
                    <v-radio
                      v-for="option in question.Options"
                      :key="option.Fserial"
                      :label="option.Title"
                      :value="option.Fserial"
                    >
                    </v-radio>
                  </v-radio-group>
                </template>
                <template v-else-if="question.Type == 2">
                  <div class="gridView">
                    <v-checkbox
                      v-for="option in question.Options"
                      :key="option.Fserial"
                      :label="option.Title"
                      :value="option.Fserial"
                      v-model="answers[index].answer['CheckBoxAnswer']"
                    >
                    </v-checkbox>
                  </div>
                </template>
                <v-textarea
                  v-else-if="question.Type == 3"
                  class="no-detail"
                  outlined
                  :rules="[rules.requiredText]"
                  maxlength="500"
                  :oninput="onInput"
                  no-resize
                  v-model="answers[index].answer['TextAnswer']"
                ></v-textarea>
              </v-col>
            </template>
          </v-row>
        </div>
        <v-row class="ltr">
          <v-btn
            color="primary white--text"
            class="register"
            rounded
            @click="clickButton"
            :disabled="apiRunning || questions.length == 0"
          >
            {{ apiRunning ? "لطفا منتظر بمانید..." : "ثبت" }}
          </v-btn>
        </v-row>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  components: {
    appRow: DetailRow,
  },
  data() {
    return {
      answers: [],

      rules: {
        requiredText: (value) => !!value || "لطفا به پرسش فوق پاسخ دهید.",
        requiredSelect: (value) =>
          !!value || "لطفا یکی از گزینه های فوق را انتخاب کنید.",
      },
    };
  },
  props: ["cycle", "recipient", "questions"],
  computed: {
    onInput() {
      return "this.value=this.value.slice(0,this.maxLength)";
    },
    fullName() {
      return this.$store.getters.FullName;
    },
    recipientDesc() {
      return (
        this.recipient.Fname +
        " " +
        this.recipient.Lname +
        " - " +
        (this.cycle.Type2 == 3
          ? this.recipient.Course_Name
          : this.recipient.Chart_Name) +
        " - " +
        this.recipient.School_Name
      );
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
  },
  methods: {
    clickButton() {
      if (this.$refs["form"].validate()) this.$emit("nextStep", this.answers);
    },
    generateAnswers(questions) {
      this.answers = [];
      for (let i = 0; i < questions.length; i++) {
        const question = questions[i];
        const item = {
          Question_Fserial: question.Fserial,
          Question_Type: question.Type,
          answer: {
            RadioAnswer: 0,
            CheckBoxAnswer: [],
            TextAnswer: "",
          },
        };

        this.answers.push(item);
      }
    },
  },
  created() {
    this.generateAnswers(this.questions);
  },
  watch: {
    questions(newvalue) {
      this.generateAnswers(newvalue);
    },
  },
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}

.register {
  width: 300px !important;
  margin: 20px auto;
}

@media only screen and (min-width: 600px) {
  .form {
    width: 570px;
    margin: 15px auto;
  }

  .col-12 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}

.v-messages__message {
  display: block !important;

  text-align: right;

  font-size: 14px;
  color: red;
  line-height: 1.5 !important;
}

.col-12 {
  padding-top: 0px !important;
}
.fullForm {
  padding: 20px 0;
}
</style>
<style>
.v-messages__message {
  display: block !important;

  text-align: right;

  font-size: 14px;
  color: red;
  line-height: 1.5 !important;
}
textarea {
  height: 80px !important;
}
.v-input--radio-group__input,
.gridView {
  display: grid !important;
}
.v-radio {
  margin-bottom: 8px !important;
}
.gridView .v-messages {
  display: none;
}

@media screen and (max-width: 992px) {
  body {
    background-color: blue;
    color: white;
  }
}

.pollRadio {
  width: 100%;
}

@media screen and (min-width: 400px) {
  .v-input--radio-group__input,
  .gridView {
    grid-template-columns: repeat(2, auto);
  }
}
@media screen and (min-width: 900px) {
  .v-input--radio-group__input,
  .gridView {
    grid-template-columns: repeat(3, auto);
  }
}
@media screen and (min-width: 1400px) {
  .v-input--radio-group__input,
  .gridView {
    grid-template-columns: repeat(4, auto);
  }
}
@media screen and (min-width: 1600px) {
  .v-input--radio-group__input,
  .gridView {
    grid-template-columns: repeat(4, auto);
  }
}
</style>
